import { Dialog, DialogContent, DialogHeader, DialogTitle } from '../ui/dialog';
import { Button } from '../ui/button';
import { AlertCircle } from 'lucide-react';

export function BalajiConfirmDialog({ 
  open, 
  onOpenChange, 
  invoiceAmount, 
  updatedInvoiceAmount, 
  onCancel, 
  onConfirm 
}) {
  const variance = Math.abs(((parseFloat(updatedInvoiceAmount || 0) - parseFloat(invoiceAmount || 0)) / parseFloat(invoiceAmount || 1)) * 100);

  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="sm:max-w-md">
        <DialogHeader>
          <DialogTitle className="text-xl font-bold text-amber-600 flex items-center gap-2">
            <AlertCircle className="w-6 h-6" />
            Invoice Amount Variance Alert
          </DialogTitle>
        </DialogHeader>
        <div className="space-y-4 mt-4">
          <div className="bg-amber-50 border border-amber-200 rounded-xl p-4">
            <p className="text-amber-800 font-medium mb-2">
              The updated invoice amount differs by more than 10% from the original invoice amount.
            </p>
            <div className="grid grid-cols-2 gap-4 mt-3">
              <div className="text-center p-3 bg-white rounded-lg">
                <p className="text-xs text-slate-500 uppercase">Original Amount</p>
                <p className="text-lg font-bold text-slate-900">₹{parseFloat(invoiceAmount || 0).toLocaleString('en-IN')}</p>
              </div>
              <div className="text-center p-3 bg-white rounded-lg">
                <p className="text-xs text-slate-500 uppercase">Updated Amount</p>
                <p className="text-lg font-bold text-blue-600">₹{parseFloat(updatedInvoiceAmount || 0).toLocaleString('en-IN')}</p>
              </div>
            </div>
            <p className="text-amber-700 text-sm mt-3">
              Variance: {variance.toFixed(1)}%
            </p>
          </div>
          <p className="text-slate-600 text-sm">
            Please double-check the amounts before proceeding. This confirmation will only appear once.
          </p>
          <div className="flex gap-3">
            <Button 
              variant="outline" 
              onClick={onCancel} 
              className="flex-1 h-11 rounded-xl"
            >
              Cancel & Review
            </Button>
            <Button 
              onClick={onConfirm} 
              className="flex-1 h-11 bg-gradient-to-r from-amber-500 to-amber-600 hover:from-amber-600 hover:to-amber-700 text-white rounded-xl"
            >
              Confirm & Submit
            </Button>
          </div>
        </div>
      </DialogContent>
    </Dialog>
  );
}
